// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__Ygvhv","title":"BackImages_title__3PupA","images":"BackImages_images__K4ddb"};